var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadNews } from 'app/stores/editor/actions/news';
import { loadConfig } from 'app/stores/editor/config';
import { HistoryActions } from 'app/stores/history/actions';
import { ImageActions } from 'app/stores/image/actions';
import { Module } from 'app/views/components/editor/text/TextModule';
import { analytics } from 'app/utils/analytics';
import { Capabilities } from 'app/utils/Capabilities';
import { getURLRegEx } from 'app/utils/varia';
import { EditorActions } from './actions';
import { setActiveTool } from './actions/tools';
import { loadProfile } from './profile';
const DefaultMobileTool = 'arrow';
export const startup = createAsyncThunk('editor/startup', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    yield dispatch(loadConfig());
    yield dispatch(loadNews());
    yield dispatch(loadProfile());
    yield Module.load('prosemirror');
    const params = new URLSearchParams(document.location.search);
    const url = (_a = params.get('url')) !== null && _a !== void 0 ? _a : params.get('u');
    if (url && url.match(getURLRegEx())) {
        analytics({ action: 'Startup', label: 'startedWithURL' });
        dispatch(ImageActions.downloadImage(url));
    }
    // try loading last image if we do not download anything
    else if (configGet('imageCacheEnabled', false)) {
        yield dispatch(ImageActions.restoreImage());
    }
    if (Capabilities.shared.isMobileDevice) {
        dispatch(setActiveTool(DefaultMobileTool));
    }
    else if (Capabilities.shared.isDesktop) {
        if (!configGet('warnBeforeUnload', true)) {
            dispatch(EditorActions.showToast({
                message: 'Be careful. You will not be warned when closing the tab.',
                variant: 'informative',
            }));
        }
    }
    dispatch(HistoryActions.unlock());
}));
